import * as React from 'react';
import { Navigate, NavigateFunction, NavigateOptions, useNavigate } from 'react-router-dom';
import { appNameUrlParam } from '../../core/constants';
import { addQueryParam } from '../../lib/utils';
import { hasValue } from '../../lib/lib';

const NavigateWithAppName = ({ to, replace = false, state = undefined }: NavigateWithAppNameProps) => {
	return <Navigate to={addAppNameQueryString(to)} replace={replace} state={state} />;
};
// TODO: Seems we don't need this appName anymore as both apps are now using the same design
export default NavigateWithAppName;

interface NavigateWithAppNameProps {
	to: string;
	replace?: boolean;
	state?: unknown;
}

const addAppNameQueryString = (to: string) => {
	const appName = getAppNameFromUrl();
	if (!hasValue(appName)) return to;

	const queryParams = [{ key: appNameUrlParam, value: appName }];
	return addQueryParam(to, queryParams); // Need to keep appName to show v2 design
};

const getAppNameFromUrl = () => {
	const params = new URLSearchParams(window.location.search);
	return params.get(appNameUrlParam) || '';
};

export const useNavigateWithAppName = (): NavigateFunction => {
	const navigate = useNavigate();

	return (to: unknown, options?: NavigateOptions) => {
		if (typeof to === 'number')
			navigate(to); // Navigate using history (e.g., -1 for back)
		else navigate(addAppNameQueryString(to as string), options);
	};
};
